import { isUsingStorageFallback } from './storageFallback';

const RELOAD_KEY = 'chunk_error_reload';
const RELOAD_WINDOW_MS = 10000;

// A failed chunk means a deploy replaced the build under this tab, so reload once to pick up
// the new one. The timestamp stops that looping. It only works if it survives the reload, and
// the in-memory fallback doesn't, so without real storage leave the error to Honeybadger.
export const reloadOnChunkError = (event, reload = () => window.location.reload()) => {
    const message = event?.reason?.message || '';
    if (!message.includes('Failed to load chunk') && !message.includes('Loading chunk')) return;
    if (isUsingStorageFallback('sessionStorage')) return;

    const lastReload = sessionStorage.getItem(RELOAD_KEY);
    const now = Date.now();
    if (!lastReload || (now - parseInt(lastReload, 10)) > RELOAD_WINDOW_MS) {
        sessionStorage.setItem(RELOAD_KEY, now.toString());
        reload();
    }
};
